export const NS_dividends = {
  DividendsMap: {
    PUA: `
            <p>
                <span class="content-cursive">
                    This illustration assumes that the dividend option is Paid-Up Additions for all years shown.
                </span>
                <span>
                    The annual dividend, if any, is used to buy additional level paid-up life insurance, adding to the policy's death benefit and total cash value. "Paid-up" means that no further premiums are required on the additional life insurance. This additional insurance is also eligible to receive dividends. Paid-up additions may be surrendered for their cash value as long as they are not being used as collateral for policy debt{{HAS_CIR_PUA}}.
                </span>
            </p>`,
    Cash: `
            <p>
                <span class="content-cursive">
                    This illustration assumes that the dividend option is Cash for all years shown.
                </span>
                <span>
                    The annual dividend, if any, is paid to the policyowner in cash.
                </span>
            </p>`,
    PRPUA: `
            <p>
                <span class="content-cursive">
                    This illustration assumes that the dividend option is Reduce Premiums with excess to Paid Up Additions for all years shown.
                </span>
                <span>
                    The prior year's annual dividend, if any, will be used to reduce premium payments. If the dividend is not enough to pay the full premium due, the balance must be paid by the end of the grace period. If this balance is not paid, we will use the dividend to pay the next smaller premium (semiannual or quarterly - but not less than quarterly) that it will cover. Premiums will then be payable at this new frequency. If the dividend exceeds the billed premium, any excess will be used to purchase additional insurance.
                </span>
            </p>`,
    PRCash: `
        <p>
            <span class="content-cursive">
                This illustration assumes that the dividend option is Reduce Premiums with excess to cash for all years shown.
            </span>
            <span>
                The prior year's annual dividend, if any, will be used to reduce premium payments. If the dividend is not enough to pay the full premium due, the balance must be paid by the end of the grace period. If this balance is not paid, we will use the dividend to pay the next smaller premium that it will cover. Premiums will then be payable at this new frequency. If the dividend exceeds the billed premium, any excess will be sent to you in cash.
            </span>
        </p>`,
    Accumulate: `
        <p>
            <span class="content-cursive">
                This illustration assumes that the dividend option is Accumulate at Interest for all years shown.
            </span>
            <span>
                Under this option, dividends, if any, are held by the company and earn interest that is credited to the policy at the end of each policy year. Interest will be at an annual rate determined by us (but not less than 2 &frac12;%) and will be compounded annually. Dividend accumulations may be withdrawn as long as they are not being used as collateral for policy debt. If dividends are left in the policy to accumulate at interest, the interest credited each year is treated as taxable income, which MassMutual must report to the Internal Revenue Service. Policyowners who select this dividend option will receive a 1099 form for the taxable interest after the end of each tax year.
            </span>
        </p>`,
  },
};
